import { clsx } from 'clsx';

import Icon from '~/src/common/components/Icon/Icon';
import Link from '~/src/common/components/Link/Link';
import I18n from '~/src/common/services/I18n';
import { RECIPE_DESCRIPTION_ID } from '~/src/screens/CatalogContent/ContentScreen/RecipeScreen/components/RecipeDescription/RecipeDescription';

import screenStyles from '../../RecipeScreen.module.scss';

import styles from './RecipeShortDescription.module.scss';

interface Props {
  shortDescription: string;
}

const DESCRIPTION_ANCHOR = `#${RECIPE_DESCRIPTION_ID}`;

export const RecipeShortDescription = (props: Props) => (
  <div
    className={clsx(
      styles.container,
      screenStyles.shortDescriptionGridPosition,
      screenStyles.shortDescription,
    )}>
    <div>{props.shortDescription}</div>

    <Link
      className={styles.details}
      href={DESCRIPTION_ANCHOR}
      onClick={e => {
        // On veut eviter l'update de l'url si possible
        const element = document.querySelector(DESCRIPTION_ANCHOR);
        if (element) {
          e.preventDefault();
          element.scrollIntoView(true);
        }
      }}>
      <span>{I18n.t('recipe-screen.view-details')}</span>
      <Icon name="arrow-down" size={16} />
    </Link>
  </div>
);
